import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import React__default from 'react';
import clsx from 'clsx';
import styles from './MediaObject.module.css.js';
import { Inline } from '../../Layout/Inline/Inline.js';

const wrapChildren = (children, className) => {
    return React__default.Children.map(children, (child, index) => {
        if (index !== 0) {
            return child;
        }
        const isChildAFragment = React__default.isValidElement(child) && child.type === React__default.Fragment;
        if (isChildAFragment) {
            return wrapChildren(child.props.children, className);
        }
        return jsxRuntimeExports.jsx("div", { className: clsx(styles.mediaItem, className), children: child });
    });
};
const MediaObject = ({ children, justify, space = 'md', align = 'start', reverse = false, mediaItemClass, }) => {
    const inlineChildren = wrapChildren(children, mediaItemClass);
    return (jsxRuntimeExports.jsx(Inline, { justify: justify, align: align, space: space, reverse: reverse, children: inlineChildren }));
};
MediaObject.displayName = 'MediaObject';

export { MediaObject };
//# sourceMappingURL=MediaObject.js.map
